var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("PortalWidget", { attrs: { widget: _vm.widgetTitle } }, [
    _c("div", [
      !_vm.isLoading
        ? _c(
            "div",
            { staticClass: "form-horizontal" },
            [
              _c("Field", {
                attrs: {
                  label: _vm.$t("ACCOUNT_BILLING_PLAN_CURRENT"),
                  "hide-label": false,
                  "has-tooltip": true,
                  "tooltip-text": _vm.$t("ACCOUNT_BILLING_PLAN_CURRENT_TT")
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "element",
                      fn: function() {
                        return [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "col-sm-4 col-md-2 p-t-7" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("titleCase")(
                                        _vm._f("planDisplayName")(
                                          _vm.billingPlan.plan.name
                                        )
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  2143012220
                )
              }),
              _vm._v(" "),
              _vm.billingPlan && _vm.billingPlan.nextChargeDT
                ? _c("Field", {
                    attrs: {
                      label: _vm.$t("NEXT_CHARGE_DATE"),
                      "hide-label": false,
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t("NEXT_CHARGE_DATE_TT")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "col-sm-4 col-md-2 p-t-7" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.formattedNextChargeDT) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2283951601
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.billingPlan &&
              (!_vm.isBillingPlanCustom || _vm.billingPlan.isBillingPlanV2)
                ? _c("Field", {
                    attrs: {
                      label: _vm.$t("ACCOUNT_BILLING_PLAN_MONTHLY_FEE"),
                      "hide-label": false,
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t(
                        "ACCOUNT_BILLING_PLAN_MONTHLY_FEE_TT"
                      )
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "col-sm-4 col-md-2 p-t-7" },
                                  [
                                    _vm._v(
                                      "\n              $" +
                                        _vm._s(
                                          (
                                            _vm.billingPlan.plan
                                              .renewingCharge || 0
                                          ).toFixed(2)
                                        ) +
                                        " /\n              " +
                                        _vm._s(
                                          _vm.billingPlan.plan
                                            .numberOfMonthsToRecur === 12
                                            ? _vm.$t(
                                                "ACCOUNT_BILLING_SCHEDULE_ANNUALLY"
                                              )
                                            : _vm.$t(
                                                "ACCOUNT_BILLING_SCHEDULE_MONTHLY"
                                              )
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3250179004
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group m-t-10" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-sm-9 col-md-9 col-md-offset-3 col-sm-offset-3"
                  },
                  [
                    _c("button", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "ACCOUNT_BILLING_VIEW_PRICING_BUTTON",
                          expression: "'ACCOUNT_BILLING_VIEW_PRICING_BUTTON'"
                        }
                      ],
                      staticClass: "btn btn-lg btn-primary",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.openModal.apply(null, arguments)
                        }
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.showModal
                ? _c("CurrentPricingModal", { on: { close: _vm.closeModal } })
                : _vm._e()
            ],
            1
          )
        : _c(
            "div",
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "LOADING",
                    expression: "'LOADING'"
                  }
                ]
              })
            ],
            1
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }